import { getSchema, type AnyExtension } from "@tiptap/core";
import StarterKit from "@tiptap/starter-kit";
import type { Schema } from "@tiptap/pm/model";

export type { Node as PMNode } from "@tiptap/pm/model";

/** Name of the Y.XmlFragment that holds the document body (TipTap Collaboration default). */
export const YDOC_FIELD = "default";

/**
 * The schema-defining extensions shared by the editor and the server.
 * The editor adds non-schema extensions (Collaboration, Placeholder, ...) on top.
 * Any change here changes what the server can export, so keep it in one place.
 */
export function schemaExtensions(): AnyExtension[] {
  return [
    StarterKit.configure({
      codeBlock: false,
      // Undo comes from Yjs' UndoManager when collaborating.
      history: false,
      heading: { levels: [1, 2, 3] },
    }),
  ];
}

let cached: Schema | undefined;

export function quillSchema(): Schema {
  cached ??= getSchema(schemaExtensions());
  return cached;
}
